<template>
    <div>
      <form @submit.prevent="submitForm">
        <div class="form-group mt-4">
            <label for="descricao" class="input-label"> 
              <span v-html="labelDescricao"></span>
            </label>
            <input id="descricao" v-model="assunto.descricao" class="form-control" />
        </div>
        <div style="text-align: right; width: 100%;" class="mb-5 mt-2">
            <!-- Outros campos conforme necessário -->
            <button type="submit" @click="SalvarAssunto();" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span>
                <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Salvar</label>
            </button>
            <button type="button" @click="$emit('closeForm')" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                <span class="material-icons" style="vertical-align: middle; color: #007BFF;">close</span>
                <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">
                    Cancelar
                </label>
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      assunto: Object,
    },
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
        };
        
    },
    methods: {
      submitForm() {
        this.$emit('closeForm');
      },
      SalvarAssunto(){
        const dados_gravar = {
            descricao: this.assunto.descricao,
            parent_id: this.assunto.parentId,
        };

        axios.post(this.BASE_URL + 'assunto_cadastrar', dados_gravar)
            .then(response => {
                if (response.status === 200) {
                    alert('Dados gravados com sucesso!');
                    window.location.reload();
                } else {
                    alert('Erro ao gravar dados.');
                }
            })
            .catch(error => {
                alert('Erro ao gravar dados: ' + error);
                console.error(error);
            });
      },
    },
    mounted(){

    },
    computed: {
    labelDescricao() {
        if (this.assunto.label_descricao === undefined) {
            return 'Descrição da nova área:';
        } else {
            return 'Cadastrar subassunto para <strong>' + this.assunto.label_descricao + '</strong>:';
        }
    }
}

  };
  </script>
  
